import { render, staticRenderFns } from "./CardProjectTable2.vue?vue&type=template&id=80d8739c"
import script from "./CardProjectTable2.vue?vue&type=script&lang=js"
export * from "./CardProjectTable2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports